module.exports = __webpack_public_path__ + "media/images/logo-e9d9d5b6.png";